import { render, staticRenderFns } from "./CarMain.vue?vue&type=template&id=b621ad0e&scoped=true&"
import script from "./CarMain.vue?vue&type=script&lang=js&"
export * from "./CarMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b621ad0e",
  null
  
)

export default component.exports